import { render, staticRenderFns } from "./discount_goods.vue?vue&type=template&id=06af5f7d&"
import script from "./discount_goods.vue?vue&type=script&lang=js&"
export * from "./discount_goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06af5f7d')) {
      api.createRecord('06af5f7d', component.options)
    } else {
      api.reload('06af5f7d', component.options)
    }
    module.hot.accept("./discount_goods.vue?vue&type=template&id=06af5f7d&", function () {
      api.rerender('06af5f7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/fee/views/record_manage/discount_goods/discount_goods.vue"
export default component.exports